// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__pArEN","modal":"modal_modal__G94jR","container":"modal_container__na6_O","closeButton":"modal_closeButton__MiAua","closeIcon":"modal_closeIcon__3lx5w"};